import React from 'react'

export default (props: any) => (
  <svg {...props} width="116" height="39" viewBox="0 0 116 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_17_322)">
      <path
        d="M0.0909119 19.5C0.0909119 30.2696 8.82136 39 19.5909 39C25.3661 39 30.555 36.4893 34.1256 32.5L29.1001 27.8205C26.8961 30.3315 23.7091 31.9091 20.1644 31.9091C13.5127 31.9091 8.12033 26.3534 8.12033 19.5C8.12033 12.6466 13.5127 7.09091 20.1644 7.09091C23.526 7.09091 26.5659 8.50976 28.7507 10.7979C28.8697 10.9226 28.9862 11.0498 29.1001 11.1795L34.0116 6.37372C33.8683 6.21647 33.7226 6.06157 33.5744 5.90909C30.0313 2.2643 25.0755 0 19.5909 0C8.82136 0 0.0909119 8.73044 0.0909119 19.5Z"
        fill="black"
      />
      <path
        d="M40.2727 19.5C40.2727 30.2696 49.0032 39 59.7727 39C65.5479 39 70.7368 36.4893 74.3074 32.5L69.2819 27.8205C67.0779 30.3315 63.8909 31.9091 60.3463 31.9091C53.6945 31.9091 48.3021 26.3534 48.3021 19.5C48.3021 12.6466 53.6945 7.09091 60.3463 7.09091C63.7078 7.09091 66.7477 8.50976 68.9325 10.7979C69.0515 10.9226 69.1681 11.0498 69.2819 11.1795L74.1934 6.37372C74.0502 6.21647 73.9044 6.06157 73.7562 5.90909C70.2132 2.2643 65.2573 0 59.7727 0C49.0032 0 40.2727 8.73044 40.2727 19.5Z"
        fill="black"
      />
      <path
        d="M80.4545 19.5C80.4545 30.2696 89.185 39 99.9545 39C105.73 39 110.919 36.4893 114.489 32.5L109.464 27.8205C107.26 30.3315 104.073 31.9091 100.528 31.9091C93.8763 31.9091 88.4839 26.3534 88.4839 19.5C88.4839 12.6466 93.8763 7.09091 100.528 7.09091C103.89 7.09091 106.93 8.50976 109.114 10.7979C109.233 10.9226 109.35 11.0498 109.464 11.1795L114.375 6.37372C114.232 6.21647 114.086 6.06157 113.938 5.90909C110.395 2.2643 105.439 0 99.9545 0C89.185 0 80.4545 8.73044 80.4545 19.5Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_17_322">
        <rect width="116" height="39" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
